export enum ContentType{
    Film,
    Series,
    Article,
    Event,
    Episode,
    Category
}